export default __webpack_public_path__ + "1dd7ad0.png";